import React from 'react';
import { Trash2 } from 'lucide-react';
import styled from 'styled-components';
import { ButtonConfig } from '../types';

const ButtonContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
  padding: 20px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  font-family: 'Inter', sans-serif;
`;

const InputGroup = styled.div`
  flex: 1;
`;

const Label = styled.label`
  display: block;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #667eea;
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  background: white;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #667eea;
  }
`;

const RemoveButton = styled.button`
  padding: 8px;
  background: #fee2e2;
  color: #dc2626;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #fecaca;
    transform: translateY(-1px);
  }
`;

interface ButtonEditorProps {
  button: ButtonConfig;
  onUpdate: (updates: Partial<ButtonConfig>) => void;
  onRemove: () => void;
}

const ButtonEditor: React.FC<ButtonEditorProps> = ({ button, onUpdate, onRemove }) => {
  return (
    <ButtonContainer>
      <InputGroup>
        <Label>Button Text</Label>
        <Input
          type="text"
          value={button.text}
          onChange={(e) => onUpdate({ text: e.target.value })}
          placeholder="Enter button text"
        />
      </InputGroup>

      <InputGroup>
        <Label>Button Link</Label>
        <Input
          type="url"
          value={button.link}
          onChange={(e) => onUpdate({ link: e.target.value })}
          placeholder="https://example.com"
        />
      </InputGroup>

      <InputGroup>
        <Label>Animation</Label>
        <Select
          value={button.animation}
          onChange={(e) => onUpdate({ animation: e.target.value as any })}
        >
          <option value="pulse">Pulse</option>
          <option value="bounce">Bounce</option>
          <option value="glow">Glow</option>
          <option value="scale">Scale</option>
        </Select>
      </InputGroup>

      <RemoveButton onClick={onRemove}>
        <Trash2 size={16} />
      </RemoveButton>
    </ButtonContainer>
  );
};

export default ButtonEditor;
